module.exports = __webpack_public_path__ + "img/coming_soon.6007650c.jpg";